<template>
  <!-- header 头部模块 -->
  <div class="header">
    <div class="con clearfix" :class="$route.path != '/' ? 'conTop' : ''">
      <div class="con_fixed">
        <div class="con_auto">
          <a href="/">
            <div class="imgBox">
              <div v-if="$route.path == '/'">
                <img v-show="menuState==true" src="/static/images/new/logoB@2x.png" />
                <img v-show="menuState==false" src="/static/images/new/logoA@2x.png" />
              </div>
              <div v-else>
                <img src="/static/images/new/logoA@2x.png" />
              </div>
            </div>
          </a>
          <!-- class="nav_box" -->
          <div class="nav_box">
            <!-- <li :class="active == 0 ? 'active' : ''" @click="hangleTop">网站首页</li> -->
            <!-- <li :class="active == 1 ? 'active' : ''" @click="hangleRoom">培训课堂</li>
            <li :class="active == 0 ? 'active' : ''" @click="hangleTop">首页</li>
            <li :class="[$route.path == '/search' ? 'active_link' : '']">
              <router-link to="/search" target="_blank" tag="a">公示公告</router-link>
            </li> -->
            <!-- <li :class="active == 1 ? 'active' : ''" @click="hangleRoom">课程分类</li> -->
            <ul class="navBox1" :class=" $route.path != '/' || menuState==false?'navBox2':''">
              <li :class="$route.path == '/' ? 'active' : ''" @click="hangleTop">首页</li>
              <!-- @click="hangleRoom" -->
              <li :class="$route.path == '/courseIndex'  ? 'active' : ''" style="position: relative;">
                <router-link to="/courseIndex" tag="div"> 课程分类 </router-link>
                <!-- 二级菜单 -->
                <!-- <div class="menu" v-show="menu2Type">
                  <ul class="menuBox">
                    <router-link to="/courseIndex" tag="div">
                      <li class="flex" @click="menu2Click(11)">
                        <div class="flex liIn">
                          <div class="iconBox">
                            <img src="/static/images/new/icon1.png" />
                          </div>
                          <span>政务课程</span>
                        </div>
                      </li>
                    </router-link>

                    <router-link to="/creditCourses" tag="div">
                      <li class="flex" @click="menu2Click(12)">
                        <div class="flex liIn">
                          <div class="iconBox">
                            <img src="/static/images/new/icon2.png" />
                          </div>
                          <span>信用课程</span>
                        </div>
                      </li>
                    </router-link>
                  </ul>
                </div> -->

              </li>
              <li :class="$route.path == '/announcement' ? 'active' : ''">
                <router-link to="/announcement" tag="a">公示公告</router-link>
              </li>
              <!-- <li :class="[$route.path == '/announcement' ? 'active_link' : '']">
                <router-link to="/search" tag="a">公示公告</router-link>
                <router-link to="/announcement" tag="a">公示公告</router-link>
              </li> -->
              <li :class="$route.path == '/services' ? 'active' : ''">
                <router-link to="/services" tag="a">服务支持</router-link>
              </li>
            </ul>
            <!--
            <div class="elMenuBox" >
              <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                <el-menu-item index="1">首页</el-menu-item>
                <el-submenu index="2">
                  <template slot="title">课程分类</template>
                  <el-menu-item index="2-1">政务课程</el-menu-item>
                  <el-menu-item index="2-2">信用课程</el-menu-item>
                </el-submenu>
                <el-menu-item index="3" >消息中心</el-menu-item>
              </el-menu>
            </div> -->



          </div>
          <div v-if="yhsm == 1" class="user already-named">
            <span class="iconfont">&#xe744;</span>已实名
          </div>
          <!-- old 登录信息展示 -->
          <!--  v-if="token && pxrXm" -->
         <!-- <div class="user" v-if="token && pxrXm">
            <div class="header-right-c">
              <img src="/static/images/user2.png" />
              <span>{{pxrXm}}</span>

              <div class="pop-box">
                <p @click="deleteAlert">退出登录</p>
              </div>
            </div>
          </div> -->


          <!-- <div class="line-one"></div> -->
          <!-- <div v-if="token && yhsm != 1" class="user real-name" @click="smrzClick()">我要实名认证</div> -->

          <!--  下拉菜单-->
          <div class="loginData"  :class="!menuState||$route.path!='/'?'loginData2':'loginData1'"  v-if="token && pxrXm">
            <el-dropdown >
              <span class="el-dropdown-link" style="cursor: pointer;">
                {{pxrXm}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <div class="flex menu menu2" @mouseenter="menu2Hover(21)" @mouseleave="menu2Hover(22)" @click="$router.push('/schedule')">
                    <div class="iconBox">
                      <img v-show="menuActive!=2" src="/static/images/new/schedule1.png" />
                      <img v-show="menuActive==2" src="/static/images/new/schedule.png" />
                    </div>
                    <span>课程进度</span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div class="flex menu menu1" @mouseenter="menu2Hover(11)" @mouseleave="menu2Hover(12)" @click="deleteAlert">
                    <div class="iconBox">
                      <img v-show="menuActive!=1" src="/static/images/new/quit1.png" />
                      <img v-show="menuActive==1" src="/static/images/new/quit.png" />
                    </div>
                    <span>退出登录</span>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <div class="user loginSwiper" v-else>
            <div class="ml20">
              <el-button size="mini" type="primary"> <a :href="loginUrl">登录</a></el-button>
            </div>
            <div class="mr20" :class="!code||$route.path!='/'?'mrzc':''">
              <a :href="loginUrl">注册</a>
            </div>
          </div>


        </div>
      </div>
      <!-- 新建培训按钮 -->
      <public-xyxf :yhsm="yhsm"></public-xyxf>

      <transition name="el-fade-in-linear">
        <div class="loginBox" v-if="$route.path == '/'">
          <div class="BoxIn">
            <div class="header_login" v-if="code">
              <!-- <div class="top_icon" @click="codeHide"></div> -->
              <div class="login_top clearfix">
                <div class="login_name">
                  <a :href="loginUrl">点我使用账号密码登录></a>
                </div>
              </div>

              <div class="login_code">
                <div class="img_box">
                  <img :src="wxCode" alt />
                </div>
                <h3>打开微信扫码登录</h3>
                <div class="login_bottom">
                  <span>还没账号?</span>
                  <a :href="loginUrl">立即注册</a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </transition>
    </div>

    <smrz ref="smrz"></smrz>
  </div>
</template>

<script>
  import Bus from "@/common/js/bus.js";
  import {
    cookie
  } from "@/common/js/cookies.js";
  import smrz from "@/components/common/shrz";
  import publicXyxf from "@/components/common/publicXyxf";
  export default {
    name: "index_header",
    props: ["activeOne", "switchActive", "fromPage"],
    data() {
      return {
        menuState:true,
        activeIndex: '1',
        timer: '',
        menuActive: null,
        timeNum: 0,
        menu2Type: false,
        loginUrl: SOWINURL + "index/login",
        qyZfzt: null,
        qyPxzt: null,
        active: 0, //判断是首页还是课堂培训
        yhsm: null,
        pxrXm: null, //账号名称
        codeTime: null, //定时器
        codeOff: false,
        uid: null, //uid传参
        code: false, //登录展示隐藏
        wxCode: null, //微信二维码
        lxId: null, //类型id
      };
    },
    computed: {
      token() {
        return cookie.get("xyxf_token_qt");
      },
      user() {
        return this.$store.state.user;
      },
    },
    beforeDestroy() {
      Bus.$off("hangleSub");
    },
    created() {
      //switchActive index父组件传入，跳转高亮
      this.active = this.switchActive || 0;

      //fromPage  index父组件传入判断不在首页导航高亮显示
      if (this.fromPage != "index") {
        this.active = null;
      }

      // 传值过来跳到培训课堂
      Bus.$on("hangleSub", (data, lxId) => {
        if (data) {
          this.lxId = lxId;
          this.active = data;
          this.hangleRoom();
        }
      });
    },
    mounted() {

      if (this.token) {
        this.getUserQy();
      } else {
        this.getWx();
      }

      this.$nextTick(() => {
        window.addEventListener("scroll", this.handleScroll, true);
      });
    },
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      },
      menu2Hover(state) {
        if (state == 11) {
          this.menuActive = 1
        } else if (state == 21) {
          this.menuActive = 2
        } else {
          this.menuActive = null
        }
      },

      // 判断二维码的 /获取当前的高度
      handleScroll() {
        let that = this;
        let scrolled =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        that.scrollTop = scrolled;
        // 样式切换
        if (scrolled > 80) {
          this.menuState=false;
        } else {
          this.menuState=true;
        }
        // 判断大于60 二维码消失
        if (this.$route.path=='/' && !this.token) {
          if (scrolled > 60) {
            this.code = false;
            this.menuState=false;
          } else {
            this.code = true;
            this.menuState=true;
          }
          console.log(this.menuState)
        }
      },
      // 返回顶部
      backtop() {
        var timer = setInterval(function() {
          let osTop =
            document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop =
            osTop + ispeed;
          this.isTop = true;
          if (osTop === 0) {
            clearInterval(timer);
          }
        }, 30);
      },
      //首页
      hangleTop() {
        this.active = 0;
        if (!this.token) {
          this.code = true;
        }
        this.$router.push("/");

        //fromPage  index父组件传入，跳转方式
        if (this.fromPage == "index") {
          this.backtop();
          this.$emit("hangleActive", this.active);
        } else {
          let routerUrl = this.$router.resolve({
            path: "/",
            query: {
              active: this.active,
            },
          });
          window.open(routerUrl.href, "_self");
        }
      },
      // 课程分类 二级菜单
      menu2Click(data) {

      },
      // 培训课堂
      hangleRoom() {
        this.active = 1;
        this.code = false;
        //fromPage  index父组件传入，跳转方式
        if (this.fromPage == "index") {
          this.backtop();
          this.$emit("hangleActive", this.active, this.lxId);
        } else {
          let routerUrl = this.$router.resolve({
            path: "/",
            query: {
              active: this.active,
            },
          });
          window.open(routerUrl.href, "_self");
        }
        console.log(this.active, "培训可挡风")
      },
      //获取微信二维码
      getWx() {
        if (this.codeOff) {
          return;
        }
        cookie.set("zdyi_time_out", 0, 1); //加上cookie
        this.codeOff = true; //开关
        this.code = true; //微信弹框
        let _self = this;
        let ajax = _self.$http.create();
        ajax({
            method: "get",
            url: SOWINURL + "index/getPCLoginQRCode",
          })
          .then(function(json) {
            // console.log(json.data);
            if (json.data.result == 1) {
              //获取二维码地址后显示弹框
              _self.wxCode = json.data.data.qrCodeUrl;
              _self.uid = json.data.data.uid;

              _self.codeTime = setInterval(function() {
                _self.setCodeInter();
              }, 5000);
            } else {
              _self.$message({
                type: "error",
                message: json.data.data,
              });
              _self.codeOff = false; //开关
            }
            // loading.close();
          })
          .catch(function(error) {
            _self.$message({
              type: "error",
              message: "二维码生成失败请刷新重试",
            });
            _self.codeOff = false; //开关
            console.log(error);
          });
      },
      //隐藏登录弹框
      codeHide() {
        this.code = false;
        let _self = this;
        clearInterval(_self.codeTime);
        _self.codeTime = null;
        _self.codeOff = false;
      },
      //重复刷新判断是否登录
      setCodeInter() {
        let _self = this;
        let ajax = _self.$http.create();
        ajax({
            method: "get",
            url: SOWINURL + "index/checkLoginResult",
            params: {
              uid: _self.uid,
            },
          })
          .then(function(json) {
            // console.log(json.data);
            if (json.data.result == 1) {
              //获取二维码地址后显示弹框
              // deleteCookie("xyxf_token_qt");
              cookie.delete("xyxf_token_qt");
              let token = json.data.data;
              cookie.set("xyxf_token_qt", token, 1);
              // setCookie("xyxf_token_qt", token, 1);
              _self.$router.go(0);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      },
      //退出账号弹框
      deleteAlert() {
        this.$confirm("是否确定退出当前账号?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            this.deleteToken();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消退出",
            });
          });
      },
      //退出账号
      deleteToken() {
        let token = cookie.get("xyxf_token_qt");
        cookie.delete("zdyi_time_out");
        cookie.delete("xyxf_token_qt");
        window.location.replace(SOWINURL + "index/logout?token=" + token);
      },
      smrzClick() {
        this.$refs["smrz"].drawer = true;
      },
      getUserQy: function(callback) {
        let _self = this;
        let ajax = _self.$http.create();
        ajax({
            method: "get",
            url: SOWINURL + "index/getUserQy",
            headers: {
              token: cookie.get("xyxf_token_qt"),
            },
          })
          .then(function(json) {
            if (json.data.result == 1) {
              _self.qyZfzt = json.data.data.qyZfzt;
              _self.yhsm = json.data.data.yhsm;
              _self.pxrXm = json.data.data.pxrXm;
              _self.qyPxzt = json.data.data.qyPxzt;
              callback && callback();
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      },
    },
    beforeDestroy() {
      clearInterval(this.codeTime);
    },
    components: {
      smrz,
      publicXyxf,
    },
  };
</script>

<style scoped lang="less">
  .flex {
    display: flex;
  }

   /deep/ .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #4799FE;
    color: #FFFFFF;
  }

  .loginData {
    /deep/ .el-dropdown-link {
      font-size: 18px;
      font-weight: bold;
    }

  }

  .loginData1 {
    /deep/ .el-dropdown-link {
      color: #ffffff;
    }
  }

  .loginData2 {
    /deep/ .el-dropdown-link {
      color: #4698FF;
    }
  }
 .menu {
      justify-content: center;
      align-items: center;

      .iconBox {
        width: 16px;
        height: 16px;
        margin-right:8px ;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  // /deep/ .el-menu{
  //   background-color: initial;
  //   border-bottom: none;
  // }

  // /deep/ .el-menu--horizontal>.el-menu-item.is-active{
  //   border-bottom: 4px solid #FFFFFF;
  // }
  // /deep/ .el-submenu:hover {
  //   background-color: initial;
  // }
  // /deep/ .is-opened{
  //   background-color: initial;
  // }
  // /deep/ .el-submenu__title:hover{
  //   color: #FFFFFF;
  // }
  .loginBox {
    width: 100%;
  }

  .BoxIn {
    width: 1180px;
    margin: 0 auto;
    position: relative;
  }



  .header_login {
    width: 300px;
    height: 300px;
    position: absolute;
    // top: 120px;
    // right: 360p0x;
    top: 15px;
    right: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 100;
    border-radius: 6px;
    // box-shadow: 0px 3px 5px rgb(0, 118, 255);
    font-size: 14px;
  }

  .login_top {
    width: 100%;
    margin-top: 22px;
    // height: 30px;
    // line-height: 30px;
    margin-bottom: 15px;
    position: relative;
    text-align: center;
  }

  .login_name {
    cursor: pointer;
    width: 150px;
    margin: 0 auto;
    // height: 30px;
    // line-height: 30px;
    // float: right;
    // border-radius: 6px;
    // border: 1px solid #d8d8d8;
    // margin-right: 56px;
  }

  .login_name a {
    font-size: 14px;
    color: #d8d8d8;
    border-bottom: 1px solid #FFFFFF;
  }

  .img_box {
    // width: 100%;
    // height: 100%;
    width: 158px;
    height: 158px;
    border-radius: 12px;
    overflow: hidden;
    margin: 0 auto;
  }

  .top_icon {
    width: 0px;
    height: 0px;
    border-top: 64px solid #fc7059;
    border-left: 64px solid transparent;
    position: absolute;
    top: 6px;
    right: 6px;
    // background: url(/static/images/rotate.png) no-repeat center center;
    cursor: pointer;
  }

  .top_icon i {
    float: right;
    color: #ffffff;
    margin-right: 6px;
    margin-top: 6px;
  }

  .login_code {
    // padding: 0 30px;
  }

  .login_code h3 {
    text-align: center;
    padding-top: 14px;
    font-size: 18px;
    color: #FFFFFF;
  }

  .login_code img {
    width: 100%;
    height: 100%;
  }

  .login_bottom {
    font-size: 12px;
    text-align: center;
    padding-top: 8px;
  }

  .login_bottom span {
    color: #FFFFFF;
  }

  .login_bottom a {
    color: #F4A028;
  }



  .nav_box {
    flex: 1;
    float: left;
    margin-left: 44px;
    font-size: 18px;

    .navBox1 {
      height: 50px;
      margin-top: 18px;

      // display: flex;
      // align-items: center;
      // justify-content: center;
      li {
        padding: 0 10px;
        float: left;
        cursor: pointer;
        font-weight: bold;
        color: #C5C7F5;



        a {
          color: #C5C7F5;
        }
      }

      li:nth-child(n + 2) {
        margin-left: 80px;
      }



      .active {
        color: #FFFFFF;
      }

      .active::after {
        display: block;
        content: "";
        width: 35px;
        height: 4px;
        border-radius: 2px;
        margin: 3px auto 0;
        background-color: #FFFFFF;
        border-radius: 2px;
      }

      .active_link {
        border-bottom: 2px solid #FFFFFF;
      }

      // 二级菜单
      .menu {
        position: absolute;
        top: 40px;
        left: 0;
        width: 141px;
        height: 90px;
        background: #FFFFFF;
        box-shadow: 0px 1px 11px 5px rgba(160, 209, 220, 0.09);
        border-radius: 8px;
        border: 1px solid #E9F0EE;
        padding: 12px 0;
        box-sizing: border-box;
        //
        transition: height 2s, transform 2s;
        -webkit-transition: height 2s, -webkit-transform 2s;



        .menuBox {
          width: 100%;

          li {
            margin: 0;
            height: 33px;
            color: #333333;
            justify-content: center;
            width: 100%;
            box-sizing: border-box;

            .liIn {
              align-items: center;
            }

            .iconBox {
              width: 16px;
              height: 16px;
              margin-right: 8px;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }

          li:hover {
            background-color: #80C4FF;
          }

          .active {
            background-color: #4799FE;
            color: #FFFFFF;
          }
        }

      }


    }

    // 首页外头部样式 //////////
    .navBox2 {
      li {
        color: #312120;

        a {
          color: #312120;
        }

      }

      .active {
        color: #312120;
      }

      .active::after {
        background-color: #4698FF;
      }
    }

    ///////end////////

  }


  .header {
    width: 100%;

    // color: #FFFFFF;
    .conTop {
      background-color: #FFFFFF;
    }

    .con {
      width: 100%;

      // background-color: #1D6AFD;
      // color: #FFFFFF;
      .con_fixed {
        width: 100%;

        // position: fixed;
        // background-color: #fff;
        // top: 0;
        // z-index: 1222;
        .con_auto {
          display: flex;
          align-items: center;
          // width: 1210px;
          width: 1180px;
          margin: 0 auto;

          .imgBox {
            width: 150px;
            height: 52px;
            float: left;
          }

          img {
            width: 100%;
            height: 100%;
          }

          .user {
            float: right;
            height: 68px;
            line-height: 68px;
            color: #FFFFFF;
            font-size: 16px;

            &.already-named {
              color: #02b213;
              margin-right: 20px;
              display: flex;
              flex-direction: row;
              align-items: center;
            }

            &.real-name {
              color: #ffa200;
              margin-right: 20px;
              text-decoration: underline;
              cursor: pointer;
              margin-left: 10px;
            }

            .iconfont {
              font-size: 16px;
              padding-right: 5px;
            }

            .header-right-c {
              position: relative;
              display: flex;
              align-items: center;

              img {
                width: 20px;
              }

              span {
                cursor: pointer;
                font-size: 16px;
                color: #FFFFFF;
                margin-left: 6px;
              }

              .pop-box {
                z-index: 999;
                line-height: 1;
                display: none;
                position: absolute;
                bottom: -50px;
                right: 0;
                padding: 10px 0;
                background-color: #fff;
                box-sizing: border-box;
                font-size: 12px;
                border: 1px solid #ebeef5;
                border-radius: 4px;
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                color: black;

                &:before {
                  width: 0px;
                  height: 0px;
                  position: absolute;
                  top: -16px;
                  right: 41px;
                  border-color: transparent transparent #fff transparent;
                  border-width: 8px;
                  border-style: solid;
                  content: "";
                  z-index: 12;
                }

                &:after {
                  width: 0px;
                  height: 0px;
                  position: absolute;
                  top: -18px;
                  right: 40px;
                  border-color: transparent transparent #ebeef5 transparent;
                  border-width: 9px;
                  border-style: solid;
                  content: "";
                  z-index: 10;
                }

                p {
                  text-align: center;
                  padding: 10px 20px;
                  box-sizing: border-box;
                  white-space: nowrap;
                  cursor: pointer;

                  &:hover {
                    color: #66b1ff;
                    background-color: #ecf5ff;
                  }
                }
              }

              &:hover .pop-box {
                display: block;
              }
            }
          }

          .loginSwiper {
            display: flex;
            flex-direction: row;
            align-items: center;
            color: #FFFFFF;

            div {
              color: #FFFFFF;
            }

            a {
              color: #FFFFFF;
            }

            .ml20 {
              margin-right: 20px;

              /deep/ .el-button span {
                font-size: 18px;
              }
            }

            .mr20 {
              font-size: 18px;
              font-weight: bold;
              // margin-left: 20px;
            }

            .mrzc {
              a {
                color: #312120;
              }
            }

            .line-one {
              width: 1px;
              height: 14px;
              background-color: #FFFFFF;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/index_header.vue